export default [
  {
    path: '/admin/defines/currencies',
    name: 'Currencies',
    component: () => import('@/views/Admin/Defines/Currencies/Index.vue'),
    meta: {
      pageTitle: 'Para Birimleri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/currencies/add',
    name: 'CurrencyAdd',
    component: () => import('@/views/Admin/Defines/Currencies/Add.vue'),
    meta: {
      pageTitle: 'Para Birimleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/currencies',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/currencies/edit/:id',
    name: 'CurrencyEdit',
    component: () => import('@/views/Admin/Defines/Currencies/Edit.vue'),
    meta: {
      pageTitle: 'Para Birimleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/currencies',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
